import React, { ReactNode } from "react";
import { Slider, SliderProps } from "@mui/material";

export type WcSliderProps = SliderProps & {
  labelDisplay?: boolean;
  color?: string;
};

export const WcSlider = ({ labelDisplay = false, color, ...props }: WcSliderProps) => {
  // for bubble effect on the slider thumb and bit bar styling
  const sx = {
    height: 8,
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&::before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1.2,
      fontSize: 12,
      background: "unset",
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      // bgcolor needed for bubble to show
      backgroundColor: "#b3b3b3",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&::before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
  };
  return <Slider valueLabelDisplay={labelDisplay ? "on" : "auto"} color={color} sx={[...(Array.isArray(sx) ? sx : [sx])]} {...props} />;
};

export default WcSlider;
